import axiosClient from "../../../../../../api/axiosClient";

const warehouseLookupService = {

  search: async () => {

    const res = await axiosClient.get(
      //"/api/ppe/material-flow/warehouse/master/list"
      "/api/ppe/material-flow/warehouse/central-store"
    );

    return res.data?.data || [];
  },

  getCentralStore: async () => {

    const res = await axiosClient.get(
      "/api/ppe/material-flow/warehouse/central-store"
      //"/api/ppe/material-flow/warehouse/master/list"
    );

    return res.data?.data || [];
  }

};

export default warehouseLookupService;